/* eslint-disable no-undef */
const mapEl = document.querySelector('.js-contacts-block__map');

if (mapEl) {
	ymaps.ready(() => {
		const mapCordinates = mapEl.dataset.cords.split(',');

		// Создание карты.
		const map = new ymaps.Map('map', {
			center: mapCordinates,
			zoom: 14,
			controls: [],
		});

		// placemark icon
		const myPlacemark = new ymaps.Placemark(
			map.getCenter(),
			{},
			{
				iconLayout: 'default#image',
				iconImageHref: 'images/icons/map-pin.svg',
				iconImageSize: [64, 64],
				iconImageOffset: [-32, -64],
			},
		);

		map.geoObjects.add(myPlacemark);
	});
}
